// extracted by mini-css-extract-plugin
export const image = "picture-module--image--1ui6h";